"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$ = exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$outboundSchema = exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$inboundSchema = exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$ = exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$outboundSchema = exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$inboundSchema = void 0;
exports.getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurityToJSON = getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurityToJSON;
exports.getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurityFromJSON = getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurityFromJSON;
exports.getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequestToJSON = getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequestToJSON;
exports.getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequestFromJSON = getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$;
(function (GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$) {
    /** @deprecated use `GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$inboundSchema` instead. */
    GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$.inboundSchema = exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$inboundSchema;
    /** @deprecated use `GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$outboundSchema` instead. */
    GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$.outboundSchema = exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$outboundSchema;
})(GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$ || (exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$ = GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$ = {}));
function getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurityToJSON(getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity) {
    return JSON.stringify(exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$outboundSchema
        .parse(getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity));
}
function getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetSecurity' from JSON`);
}
/** @internal */
exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$inboundSchema = z.object({
    "filter[current_efficiency_rating]": z.number().int().optional(),
    "filter[epc_rating]": shared.EnergyEfficiencyRatings$inboundSchema
        .optional(),
    "filter[lodgement_date]": z.string().optional(),
    "filter[max_lodgement_date]": z.string().optional(),
    "filter[min_lodgement_date]": z.string().optional(),
    "filter[potential_efficiency_rating]": z.number().int().optional(),
    postcode: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[current_efficiency_rating]": "filterCurrentEfficiencyRating",
        "filter[epc_rating]": "filterEpcRating",
        "filter[lodgement_date]": "filterLodgementDate",
        "filter[max_lodgement_date]": "filterMaxLodgementDate",
        "filter[min_lodgement_date]": "filterMinLodgementDate",
        "filter[potential_efficiency_rating]": "filterPotentialEfficiencyRating",
    });
});
/** @internal */
exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$outboundSchema = z.object({
    filterCurrentEfficiencyRating: z.number().int().optional(),
    filterEpcRating: shared.EnergyEfficiencyRatings$outboundSchema.optional(),
    filterLodgementDate: z.string().optional(),
    filterMaxLodgementDate: z.string().optional(),
    filterMinLodgementDate: z.string().optional(),
    filterPotentialEfficiencyRating: z.number().int().optional(),
    postcode: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterCurrentEfficiencyRating: "filter[current_efficiency_rating]",
        filterEpcRating: "filter[epc_rating]",
        filterLodgementDate: "filter[lodgement_date]",
        filterMaxLodgementDate: "filter[max_lodgement_date]",
        filterMinLodgementDate: "filter[min_lodgement_date]",
        filterPotentialEfficiencyRating: "filter[potential_efficiency_rating]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$;
(function (GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$) {
    /** @deprecated use `GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$inboundSchema` instead. */
    GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$.inboundSchema = exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$inboundSchema;
    /** @deprecated use `GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$outboundSchema` instead. */
    GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$.outboundSchema = exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$outboundSchema;
})(GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$ || (exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$ = GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$ = {}));
function getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequestToJSON(getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest) {
    return JSON.stringify(exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$outboundSchema
        .parse(getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest));
}
function getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGetRequest' from JSON`);
}
//# sourceMappingURL=getenergyperformancecertificatespostcodespostcodeenergyperformancecertificatesget.js.map